import axios from 'axios';
import store from '../store/index';
import router from '../router';
import Vue from 'vue';
import { parseErrorMessage } from '@mtntop/utils/src/utils/http';
axios.defaults.timeout = 1000 * 60 * 3; //2minutes
export const isProd = (process.env.VUE_APP_APIURL || '').match('https');
const VERSION = '2.0.0';
const ALL_HTTP = {};
let lastGlobalErrorNotify = { text: '', at: 0 };

export const notifyAppError = (message) => {
  if (message === undefined || message === null) return;
  const text = typeof message === 'string' ? message.trim() : String(message).trim();
  if (!text) return;
  const now = Date.now();
  if (lastGlobalErrorNotify.text === text && now - lastGlobalErrorNotify.at < 600) return;
  lastGlobalErrorNotify = { text, at: now };
  Vue.notify({
    group: 'app',
    type: 'error',
    title: 'Error',
    text,
    closeOnClick: true,
    duration: 30000
  });
};

export { parseErrorMessage };
export function getStoredToken() {
  return sessionStorage.getItem('access_token_4') || localStorage.getItem('access_token');
}
const HTTPV = (baseURL, token, api_token, fresh) => {
  if (!baseURL) baseURL = process.env.VUE_APP_APIURL;
  if (ALL_HTTP[baseURL] && !fresh) return ALL_HTTP[baseURL];
  const tempToken = Object.fromEntries(new URLSearchParams(window.location.search).entries()).tempToken;
  const psCode =
    location.pathname.toLowerCase().startsWith('/promo-requests') && location.pathname.toLowerCase().split('/')[3];
  const config = {
    baseURL,
    withCredentials: false,
    headers: {
      version: VERSION,
      ...(tempToken && { tempToken }),
      ...(psCode && { psCode }),
      ...((token || getStoredToken()) && {
        authorization: token || getStoredToken()
      })
    }
  };
  let ajaxDom;
  ajaxDom = document.createElement('input');
  ajaxDom.setAttribute('type', 'hidden');
  ajaxDom.setAttribute('data-id', 'mPower-Ajax-freeze');
  document.body.appendChild(ajaxDom);
  const urlParams = new URLSearchParams(window.location.search);
  const artToken = urlParams.get('token');
  if (artToken) config.headers.arttoken = artToken;

  if (api_token) {
    config.apitoken = api_token;
  }

  const HTTP = (ALL_HTTP[baseURL] = axios.create(config));
  HTTP.defaults.timeout = 1000 * 60 * 3; //2minutes
  HTTP.interceptors.request.use(
    function (config) {
      if (config.url.includes('/asi/suppliers')) {
        config.url = `/distributor_portal${config.url}`;
        config.baseURL = `${process.env.VUE_APP_APIURL}/ps-api`;
      }
      config.headers.portal = 'app';

      const PORTAL = (location.pathname.split('/').filter((el) => el)[0] || '').toLowerCase();
      if (['admin', 'supplier', 'art'].includes(PORTAL)) {
        config.headers.portal = PORTAL;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const e2eFromUrl = urlParams.get('e2e') === '1' || urlParams.get('e2e') === 'true';
      if (e2eFromUrl) {
        try {
          sessionStorage.setItem('mpower-e2e', '1');
        } catch (e) {}
      }
      const isE2E = e2eFromUrl || (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('mpower-e2e') === '1');
      if (isE2E) {
        config.headers['mpower-e2e'] = 'true';
      }

      return config;
    },
    function (error) {
      // Do something with request error
      if (ajaxDom?.parentNode) ajaxDom.parentNode.removeChild(ajaxDom);
      return Promise.reject(error);
    }
  );

  HTTP.interceptors.response.use(
    (response) => {
      const n = response.data && response.data.$$notification;
      if (n && n.success) {
        Vue.notify({
          group: 'app',
          type: 'success',
          text: n.success
        });
      }
      if (n && n.error) {
        notifyAppError(n.error);
      }
      // if (ajaxDom?.parentNode) ajaxDom.parentNode.removeChild(ajaxDom);
      return response;
    },
    (error) => {
      // if (ajaxDom?.parentNode) ajaxDom.parentNode.removeChild(ajaxDom);
      if (error.response) {
        if (error.response.status === 401) {
          const sentToken =
            error.config?.headers?.authorization || error.config?.headers?.Authorization || '';
          const currentToken = store.state.auth?.token || getStoredToken() || '';
          if (sentToken && sentToken === currentToken) {
            store.dispatch('auth_logout');
          }
        }

        const data = error.response.data;

        if (data?.$$notification?.error) {
          notifyAppError(data.$$notification.error);
        } else if (
          error.response.status !== 401 &&
          error.response.status !== 409 &&
          error.response.status !== 428
        ) {
          const text = parseErrorMessage(error.response);
          notifyAppError(typeof text === 'string' ? text : '');
        }
      }
      /*if (error.response.status !== 404) {
                        createError({
                          errorType: 'Server',
                          method: error.response.config.method,
                          url: error.response.config.url,
                          message: error.response.data.message,
                          status: error.response.status
                        });
                      }*/
      return Promise.reject(error.response || error);
    }
  );
  return ALL_HTTP[baseURL];
};

const HTTP = HTTPV();
export { HTTP as default, HTTPV };
